import '../App.css';
import PictureBanner from '../assets/img/bg-nos-ap.jpg';
import franceAcapAbbVie from '../assets/img/france-acap-abbvie.png';
import Hero from '../components/Hero';
import { Helmet } from "react-helmet";

function AP() {

  const hero = {
    banner: PictureBanner,
    title: 'Nos accès précoces (AP)',
    subtitle: 'Les accès précoces',
    items: [
      {
        title: 'EPCORITAMAB',
        subtitle: 'Lymphome Diffus à Grande Cellule B',
        popup: {
          popupTitle: 'Depuis le 21 octobre 2026, le site dédié à l\'Accès Précoce epcoritamab n\'est plus disponible',
          popupContent: (
            <>
              <p><em>Indication : epcoritamab en monothérapie pour le traitement des patients adultes atteints d'un lymphome diffus à grandes cellules B (LDGCB) en rechute ou réfractaire après au moins deux lignes de traitement systémique, inéligibles à l'ensemble des traitements disponibles ou en échec des médicaments à base de cellules CAR-T</em></p>
              <p>Ce site a été définitivement fermé et n'est désormais plus accessible</p>
              <p>Pour toute question concernant le suivi des patients, nous vous invitons à contacter la cellule en charge des accès dérogatoires (ACAP : Accès Compassionnel - Accès Précoce)</p>
              <p><a href="mailto:France.acap@abbvie.com" target="_blank" rel="noreferrer">France.acap@abbvie.com</a></p>
              <p><img src={franceAcapAbbVie} alt="France ACAP AbbVie" /></p>
              <p className="small">FR-EPCOR-260001 - 11/2026</p>
            </>
          )
        }
      },
      {
        title: 'MIRVETUXIMAB SORAVTANSINE',
        subtitle: 'Cancer de l\'ovaire',
        link: 'https://ap-elahere.com'
      }
    ],
    noItems: 'Pas d\'AP actuellement',
    breadcrumb: [
      {
        title: 'Vraie-Vie',
        link: '/'
      },
      {
        title: 'Nos AP'
      }
    ]
  }

  return (
    <>
      <Helmet>
        <title>Nos accès précoces | AbbVie Vraie Vie</title>
        <meta
          name="description"
          content="Portail ATU, RTU, Etudes"
        />
      </Helmet>
      <Hero 
        key={'hero-AP'}
        banner={hero.banner}
        title={hero.title}
        subtitle={hero.subtitle}
        items={hero.items}
        noItems={hero.noItems}
        breadcrumb={hero.breadcrumb}
      />
      <p className='text-xxl'>
        Des médicaments qui ne bénéficient pas d'une Autorisation de Mise sur le Marché (AMM) dans une indication considérée ou qui n'ont pas encore été admis au remboursement par l'Assurance Maladie dans cette indication peuvent, à titre exceptionnel, faire l'objet d'autorisation d'ACCES PRECOCE délivrés par la Haute Autorité de Santé (HAS).
      </p>
      <div className='abbvie-container'>
        <div className="medium-container">
          <div className='flex2'>
            <h2>Pour ce faire, les <strong>4 conditions d'accès</strong> suivantes doivent être réunies :</h2>
          </div>
          <div className='flex3'>
            <ul>
              <li>Le médicament doit être destiné à traiter des maladies graves, rares ou invalidantes,</li>
              <li>Il n'existe pas de traitement approprié disponible,</li>
              <li>La mise en œuvre du traitement ne peut pas être différée,</li>
              <li>Le médicament est présumé innovant, notamment au regard d'un éventuel comparateur cliniquement pertinent.</li>
            </ul>
          </div>
        </div>
      </div>
      <p className='text-md'>
        AbbVie collabore étroitement avec la HAS et l'ANSM à la mise en place d'ACCES PRECOCES selon les modalités fixées dans le Protocole d’Utilisation Thérapeutique et de Recueil des Données (PUT-RD).<br/>
        Le référentiel des accès précoces en cours est disponible sur le site de l'ANSM (https://ansm.sante.fr/documents/reference/referentiel-des-specialites-en-acces-derogatoire)<br/>
        Toute demande pour faire bénéficier un patient d'un ACCES PRECOCE en cours avec un médicament AbbVie se fait via le site «AbbVie Vraie Vie ».
      </p>
      <p className='tac'>FR-ABBV-260095 – 04/2026</p>
    </>
  )
}

export default AP;
